import { Box, Button, CircularProgress, IconButton, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { useAtomValue, useSetAtom } from 'jotai';
import { AbyssIcon } from '@/assets/icons/AbyssIcon';
import * as kpiState from '../../state';
import { Pill } from '@/components/shared/Pill';
import { useWorkpackForKpiTrackerQuery, LogTemplateType } from '@/__generated__/graphql';

type Props = {
  isSubmitting: boolean;
  isDirty: boolean;
  isValid: boolean;
};

const headerContainerRowStyles = {
  display: 'flex',
  alignItems: 'center',
  px: 3,
  pt: 2,
  pb: 1,
  borderBottom: '1px solid',
  borderBottomColor: 'divider',
} as const;

const flexRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
} as const;

export const KpiPanelHeader = ({ isSubmitting, isDirty, isValid }: Props) => {
  const setIsOpen = useSetAtom(kpiState.kpiPanelOpen);
  const selectedWorkpackId = useAtomValue(kpiState.selectedWorkpackIdForKpiTracker);
  const selectedLogTemplateType = useAtomValue(kpiState.selectedLogTemplateType);

  const { data: workpackData } = useWorkpackForKpiTrackerQuery({
    variables: { workpackId: selectedWorkpackId },
    skip: !selectedWorkpackId,
  });

  const workpackName = workpackData?.workpack?.name;

  const handleClose = () => setIsOpen(false);

  return (
    <Box sx={{ ...headerContainerRowStyles, justifyContent: 'space-between' }}>
      {/* Left section */}
      <Box sx={flexRowStyles}>
        <Typography variant="h4" sx={{ fontWeight: 500, color: 'text.primary', fontSize: '2rem' }}>
          {selectedLogTemplateType === LogTemplateType.CostLogTemplate ? 'Log Cost' : 'Log work'}
        </Typography>

        {selectedLogTemplateType === LogTemplateType.WorklogTemplate && (
          <Pill label={workpackName || ''} state="default" size="medium" disabled />
        )}

        <AbyssIcon iconName="beta" size="lg" />
      </Box>

      <Box sx={flexRowStyles}>
        <Button
          id="kpi-tracker-save-worklogs-button"
          type="submit"
          size="small"
          variant="contained"
          disabled={isSubmitting || !isDirty || !isValid}
          startIcon={isSubmitting ? <CircularProgress size={16} color="inherit" /> : <CheckIcon />}
        >
          {isSubmitting ? 'Saving...' : 'Save'}
        </Button>

        <IconButton onClick={handleClose} size="small">
          <CloseIcon sx={{ color: 'text.primary' }} />
        </IconButton>
      </Box>
    </Box>
  );
};
